import { useRef } from 'react';
import { createVgsCollectForm } from '../../../services/vgs/collect/form';
import useVgsScripts from './useVgsScripts';
import useLastEffect from '../../../hooks/useLastEffect';

export default function useVgsCollect<T>(): VGSForm<T> | undefined {
  const vgsCollectForm = useRef<VGSForm<T>>();
  const vgsScriptsLoaded = useVgsScripts();
  useLastEffect((): boolean => {
    if (vgsCollectForm.current !== undefined || !vgsScriptsLoaded) {
      return false;
    }
    vgsCollectForm.current = createVgsCollectForm();
    return true;
  }, [vgsScriptsLoaded]);
  return vgsCollectForm.current;
}
